/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_PremiumInputs */

const en_mk_mx_premium = /** @type {(inputs: Mk_Mx_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium model credits per month`)
};

const id_mk_mx_premium = /** @type {(inputs: Mk_Mx_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredit model premium per bulan`)
};

/**
* | output |
* | --- |
* | "Premium model credits per month" |
*
* @param {Mk_Mx_PremiumInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_premium = /** @type {((inputs?: Mk_Mx_PremiumInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_PremiumInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_premium(inputs)
	return en_mk_mx_premium(inputs)
});